import { intToStr } from '../int-string';
import { decimalSeparator } from './decimal-separator';

export function baseUnitQuantityToAmountString({
  baseUnitQuantity,
  baseUnitDecimalDigits = 2,
  minIntegerDigits = 1,
}: {
  baseUnitQuantity: number;
  baseUnitDecimalDigits?: number;
  minIntegerDigits?: number;
}): string {
  const baseUnitQuantityStr = intToStr(
    baseUnitQuantity,
    minIntegerDigits + baseUnitDecimalDigits,
  );

  const integerPart = baseUnitQuantityStr.slice(
    0,
    baseUnitQuantityStr.length - baseUnitDecimalDigits,
  );

  const decimalPart = baseUnitQuantityStr.slice(-baseUnitDecimalDigits);

  return `${integerPart}${decimalSeparator}${decimalPart}`;
}
